
import { AgGridReact } from 'ag-grid-react'

import React from 'react'
import { useAlert } from 'react-alert'
import { Error, Header, Loader } from '../components'
import { useGetResidentsQuery } from '../redux/residents/residentApi'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import { useStateContext } from '../contexts/ContextProvider'


const Residents = () => {

    // <ColumnsDirective>
    //                 <ColumnDirective field='_id' headerText='Resident id' width='100' />
    //                 <ColumnDirective field='name' headerText='Resident Name' />
    //                 <ColumnDirective field='email' headerText='Resident Email' />
    //             </ColumnsDirective>

    const { data, isLoading, error } = useGetResidentsQuery()
    const { currentMode } = useStateContext()
    const alert = useAlert()

    const defaultColDefs = {
        sortable: true, filter: true,
    }

    const columnsDefs = [
        { field: "name", flex: 2, },
        { field: 'email', flex: 2 },
        { field: 'address.house', headerName: "🏠", flex: 1 },
        { field: 'address.street', headerName: "Street", flex: 1 },
        { field: 'address.block', headerName: "Block", flex: 1 },

    ]


    if (isLoading) return <Loader />

    if (error) {
        alert.error(alert.data.message)
        alert.removeAll()
        return <Error />
    }

    return (
        <div className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${currentMode === 'Dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'} h-[500px]`}>
            <Header title="Residents 🏠👨‍👩‍👧‍👦 " category="Page" />
            <div className='h-[70%] w-[100%] ' style={{

            }}>

                <AgGridReact rowData={data.users} columnDefs={columnsDefs} defaultColDef={defaultColDefs} animateRows={true} />
            </div>


        </div>
    )
}

export default Residents

